const carouselItems = [
  {
    id: 1,
    title: '韩漫季 · 都市恋爱剧场',
    desc: '精选30部高分韩漫恋爱作品，霸道总裁、契约婚姻、青梅竹马……各类CP一网打尽。沉浸式下拉阅读，体验韩式浪漫的极致张力。',
    tag: '韩漫专题',
    imgUrl: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20themed%20banner%20illustration%20with%20warm%20coral%20and%20cream%20gradient%2C%20soft%20artistic%20style%2C%20elegant%20composition%2C%20dreamy%20atmosphere%2C%20modern%20manhwa%20aesthetic%2C%20no%20text&width=1200&height=500&seq=carousel-banner-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国漫之光 · 玄幻修仙盛宴',
    desc: '从斗破乾坤到绝世神医，玄幻国漫强势崛起。热血战斗、逆天改命、修仙飞升，一口气追完全集，感受国风漫画的独特魅力。',
    tag: '国漫专题',
    imgUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20themed%20banner%20illustration%20with%20warm%20amber%20and%20cream%20gradient%2C%20epic%20artistic%20style%2C%20dynamic%20composition%2C%20mystical%20atmosphere%2C%20modern%20manhua%20aesthetic%2C%20no%20text&width=1200&height=500&seq=carousel-banner-02&orientation=landscape',
  },
  {
    id: 3,
    title: '日漫新番 · 2026夏季特辑',
    desc: '本季日漫新番大爆发！奇幻冒险、校园恋爱、悬疑推理三大赛道齐头并进，编辑精选20部必追神作，抢先锁定你的夏季追更清单。',
    tag: '日漫专题',
    imgUrl: 'https://readdy.ai/api/search-image?query=Summer%20manga%20themed%20banner%20illustration%20with%20warm%20coral%20and%20cream%20gradient%2C%20bright%20artistic%20style%2C%20refreshing%20composition%2C%20youthful%20atmosphere%2C%20modern%20anime%20aesthetic%2C%20no%20text&width=1200&height=500&seq=carousel-banner-03&orientation=landscape',
  },
  {
    id: 4,
    title: '下拉式特辑 · 沉浸阅读新体验',
    desc: '羞羞漫画独家下拉式阅读技术，无需翻页，内容自动加载，给你一气呵成的沉浸感。搭配夜间模式和离线缓存，随时随地畅享漫画世界。',
    tag: '体验专题',
    imgUrl: 'https://readdy.ai/api/search-image?query=Digital%20reading%20themed%20banner%20illustration%20with%20warm%20coral%20and%20cream%20gradient%2C%20modern%20tech%20style%2C%20clean%20composition%2C%20innovative%20atmosphere%2C%20minimal%20aesthetic%2C%20no%20text&width=1200&height=500&seq=carousel-banner-04&orientation=landscape',
  },
  {
    id: 5,
    title: '新人必看 · 入坑指南合集',
    desc: '刚开始看漫画不知道从哪入手？我们为你整理了覆盖全类型的入门推荐清单。韩漫日漫国漫各5部代表作，零门槛快速上手，漫画世界从这里开始。',
    tag: '推荐专题',
    imgUrl: 'https://readdy.ai/api/search-image?query=Guide%20manga%20themed%20banner%20illustration%20with%20warm%20coral%20and%20cream%20gradient%2C%20welcoming%20artistic%20style%2C%20friendly%20composition%2C%20inviting%20atmosphere%2C%20modern%20aesthetic%2C%20no%20text&width=1200&height=500&seq=carousel-banner-05&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-focus-2-line text-accent-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">焦点专题</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">编辑精选专题内容，深度探索漫画世界</p>

        <div className="flex flex-col gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative overflow-hidden rounded-2xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-2/5 xl:w-1/3 flex-shrink-0">
                  <div className="relative w-full h-48 lg:h-full min-h-[200px] overflow-hidden bg-background-200">
                    <img
                      src={item.imgUrl}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                    <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">{item.tag}</span>
                  </div>
                </div>
                <div className="flex-1 p-5 md:p-7 flex flex-col justify-center">
                  <h3 className="text-lg md:text-xl font-semibold text-foreground-800 mb-3 group-hover:text-accent-500 transition-colors">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  <div className="mt-4">
                    <span className="inline-flex items-center gap-1.5 text-sm text-accent-500 font-medium whitespace-nowrap">
                      查看专题
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}